<template>
  <v-menu v-model="menu_ativo" :close-on-content-click="false" transition="scale-transition">
    <template v-slot:activator="{}">
      <SysBtn :class="classContentButtom" :size="3" @click="menu_ativo = !menu_ativo">
        <slot name="texto-btn-ativador" :periodo_analise="periodo_analise">
          <v-icon size="18">mdi-calendar-blank</v-icon>
          <span class="ml-1">Período Análise</span>
          <span class="font-12 text-gray-900 ml-2px">(de {{ data_inicial_atual }} até {{ data_final_atual }})</span>
        </slot>
      </SysBtn>
    </template>

    <div class="bg-white">
      <div class="d-flex align-center pa-2">
        <v-icon :size="20">mdi-calendar-blank</v-icon>
        <span class="font-16 font-weight-medium ml-1">
          <slot name="titulo">Período da Análise</slot>
        </span>

        <v-spacer />

        <v-btn icon @click="menu_ativo = false">
          <v-icon :size="22">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="px-3">
        <div class="d-flex align-center pb-3">
          <div class="w-300 mr-1">
            <v-select
              v-model="periodo_analise.inicial.tipo_data"
              label="Tipo da data"
              :items="selects.tipos_data_inicial"
              hide-details
              outlined
              dense
              @change="periodo_analise.final.tipo_data = '';periodo_analise.final.data = '';"
            />
          </div>

          <div v-if="data_atual" class="w-160 ml-1">
            <TextFieldDate
              v-model="periodo_analise.inicial.data"
              label="Data Inicial"
              hide-details
              outlined
              dense
              :min="datas_historico_diagnostico[0] || null"
              :max="data_atual"
              type="date"
              :disabled="periodo_analise.inicial.tipo_data !== 3"
              :props_date_picker="{
                allowedDates: datasInicialPermitidasParaSelecao
              }"
              :bottom="menuDatePickerBottom"
              :left="menuDatePickerLeft"
              @update:modelValue="periodo_analise.final.tipo_data = '';periodo_analise.final.data = '';"
            />
          </div>
        </div>

        <div class="d-flex align-center pb-2">
          <div class="w-300 mr-1">
            <v-select
              v-model="periodo_analise.final.tipo_data"
              label="Tipo da data"
              :items="TIPOS_DATA_FINAL"
              hide-details
              outlined
              dense
            />
          </div>

          <div v-if="data_atual" class="w-160 ml-1">
            <TextFieldDate
              v-model="periodo_analise.final.data"
              label="Data Final"
              hide-details
              outlined
              dense
              :min="periodo_analise.inicial.data"
              :max="data_atual"
              type="date"
              :props_date_picker="{
                allowedDates: datasFinaisPermitidasParaSelecao
              }"
              :disabled="periodo_analise.final.tipo_data !== 3"
              :bottom="menuDatePickerBottom"
              :left="menuDatePickerLeft"
            />
          </div>
        </div>

        <div class="d-flex align-center justify-end pb-2">
          <v-btn small class="ml-2" color="#0a3950" :dark="HABILITAR_SALVAMENTO" :disabled="!HABILITAR_SALVAMENTO" @click="salvarPeriodoAnalise">
            salvar
          </v-btn>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import {buscarPeriodoAnalise, salvarPeriodoAnalise} from "@/api/Diagnostico/SlowNoMoving/IndicadorEvolucaoSlowNoMoving";
import {logout} from "@/helpers";
import TextFieldDate from "./TextFieldDate.vue";

export default {
  name: "FiltroDataInicialFinal",
  components: {TextFieldDate},
  emits: [
    'update:periodo-analise',
    'update:periodo-analise-data-inicial',
    'update:periodo-analise-data-final'
  ],
  props: {
    data_inicial_atual: String,
    data_final_atual: String,
    classContentButtom: {
      type: String,
      default: 'ml-4'
    },
    menuDatePickerBottom: Boolean,
    menuDatePickerLeft: Boolean,
  },
  data: () => ({
    menu_ativo: false,
    periodo_analise: {
      inicial: {
        tipo_data: '',
        data: '',
      },
      final: {
        tipo_data: '',
        data: '',
      }
    },
    selects: {
      tipos_data_inicial: [
        {text: "1. Início do mês fechado", value: 1},
        {text: "2. Início do mês corrente", value: 2},
        {text: "3. Data específica", value: 3},
      ],
      tipos_data_final: [
        {text: "1. Final do mês fechado", value: 1},
        {text: "2. Último dia do mês corrente", value: 2},
        {text: "3. Data específica", value: 3},
      ]
    },
    data_atual: '',
    datas_opcoes_logicas: {
      inicial: {
        primeiro_dia_mes_fechado: '',
        primeiro_dia_mes_corrente: '',
      },
      final: {
        ultimo_dia_mes_fechado: '',
        ultimo_dia_mes_corrente: ''
      }
    },
    datas_historico_diagnostico: []
  }),
  computed: {
    TIPOS_DATA_FINAL() {
      if (this.periodo_analise.inicial.tipo_data !== 2) {
        return this.selects.tipos_data_final;
      }

      return this.selects.tipos_data_final.filter(item => item.value > 1);
    },
    DATA_INICIAL() {
      return (this.periodo_analise.inicial.tipo_data === 3)
        ? this.periodo_analise.inicial.data : this.periodo_analise.inicial.tipo_data;
    },
    DATA_FINAL() {
      return (this.periodo_analise.final.tipo_data === 3)
        ? this.periodo_analise.final.data : this.periodo_analise.final.tipo_data;
    },
    HABILITAR_SALVAMENTO() {
      return String(this.DATA_INICIAL).length > 0 && String(this.DATA_FINAL).length > 0;
    }
  },
  watch: {
    'periodo_analise.inicial.tipo_data': function () {
      this.setDataInicialPorTipoLogico();
    },
    'periodo_analise.final.tipo_data': function () {
      this.setDataFinalPorTipoLogico();
    },
    data_inicial_atual() {
      if (!this.data_inicial_atual) return;

      if (this.periodo_analise.inicial.tipo_data === 3) {
        this.periodo_analise.inicial.data = this.formatarDataParaFormatoAmericano(this.data_inicial_atual);
      }
    },
    'periodo_analise.inicial.data': function (data) {
      this.$emit('update:periodo-analise-data-inicial', data);
    },
    'periodo_analise.final.data': function (data) {
      this.$emit('update:periodo-analise-data-final', data);
    }
  },
  mounted() {
    this.buscarPeriodoAnalise();
  },
  methods: {
    formatarDataParaFormatoAmericano(data) {
      return data.split("/").reverse().join("-");
    },
    buscarPeriodoAnalise() {
      this.$store.dispatch("loading/addRequisicao",
        buscarPeriodoAnalise()
          .then(this.setPeridoAnaliseAtual)
          .catch(logout)
      );
    },
    setPeridoAnaliseAtual({periodo_analise, datas_historico_diagnostico}) {
      this.datas_historico_diagnostico = datas_historico_diagnostico;

      this.data_atual = periodo_analise.data_atual;

      this.datas_opcoes_logicas.inicial = periodo_analise.datas_iniciais;
      this.datas_opcoes_logicas.final = periodo_analise.datas_finais;

      this.setPeriodoAnaliseDataInicialAtual(periodo_analise.atual.inicial);
      this.setPeriodoAnaliseDataFinalAtual(periodo_analise.atual.final);
    },
    setPeriodoAnaliseDataInicialAtual(periodo_inicial) {
      this.periodo_analise.inicial.tipo_data = parseInt(periodo_inicial.tipo_data);

      if (this.periodo_analise.inicial.tipo_data === 3 && periodo_inicial.data) {
        this.periodo_analise.inicial.data = periodo_inicial.data;
      }
    },
    setPeriodoAnaliseDataFinalAtual(periodo_final) {
      this.periodo_analise.final.tipo_data = parseInt(periodo_final.tipo_data);

      if (this.periodo_analise.final.tipo_data === 3) {
        this.periodo_analise.final.data = !periodo_final.data ? this.data_atual : periodo_final.data;
      }
    },
    salvarPeriodoAnalise() {
      const parametros = {
        data_inicial: this.DATA_INICIAL,
        data_final: this.DATA_FINAL,
      };

      this.$store.dispatch("loading/addRequisicao",
        salvarPeriodoAnalise(parametros)
          .then(() => {
            this.$emit("update:periodo-analise", {});
            this.menu_ativo = false;
          })
          .catch(logout)
      );
    },
    setDataInicialPorTipoLogico() {
      if (this.periodo_analise.inicial.tipo_data === 1) {
        this.periodo_analise.inicial.data = this.datas_opcoes_logicas.inicial.primeiro_dia_mes_fechado;
      }

      if (this.periodo_analise.inicial.tipo_data === 2) {
        this.periodo_analise.inicial.data = this.datas_opcoes_logicas.inicial.primeiro_dia_mes_corrente;
      }
    },
    setDataFinalPorTipoLogico() {
      if (this.periodo_analise.final.tipo_data === 1) {
        this.periodo_analise.final.data = this.datas_opcoes_logicas.final.ultimo_dia_mes_fechado;
      }

      if (this.periodo_analise.final.tipo_data === 2) {
        this.periodo_analise.final.data = this.datas_opcoes_logicas.final.ultimo_dia_mes_corrente;
      }
    },
    datasInicialPermitidasParaSelecao(data) {
      const datas_diferentes_da_data_atual = this.datas_historico_diagnostico.slice(0, -1);
      return datas_diferentes_da_data_atual.includes(data);
    },
    datasFinaisPermitidasParaSelecao(data) {
      const datas_diferentes_da_data_parametrizacao = this.datas_historico_diagnostico.slice(1);
      return datas_diferentes_da_data_parametrizacao.includes(data)
        && this.periodo_analise.inicial.data !== data;
    }
  }
}
</script>

<style scoped>

</style>
